<template>
    <header>
        <div class="header_container">
            <div class="header_control">
                <a class="company_logo" href="https://www.blind.co.jp/"><img src="../../assets/img/logo.svg" alt="タチカワブラインド" width="189" height="20"></a>
                <nav class="header_nav" v-if="!bootup">
                    <button class="btn_check" @click="setModal('CheckItem')">
                        製品を確認
                    </button>
                    <button type="button" class="btn_delete" @click="setModal('ComfirmReset')">
                        <svg xmlns="http://www.w3.org/2000/svg" width="7.579" height="8.761" viewBox="0 0 7.579 8.761"><path d="M550.878,473.692a3.79,3.79,0,0,0,.006-7.579v-1.181l-2.6,1.822,2.6,1.822v-1.182a2.508,2.508,0,1,1-2.515,2.508h-1.281A3.79,3.79,0,0,0,550.878,473.692Z" transform="translate(-547.088 -464.931)"/></svg>
                        全製品リセット
                    </button>
                    <button type="button" class="btn_add_item" @click="setupTempItem">
                        <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8"><g transform="translate(-342 -34)"><path d="M8,.5H0v-1H8Z" transform="translate(342 38)"/><path d="M.5,8h-1V0h1Z" transform="translate(346 34)"/></g></svg>
                        製品を追加
                    </button>
                </nav>
            </div>
            <div class="logo_container">
                <button type="button" class="btn_help" @click="$emit('openHelp')"  v-if="!bootup">
                    <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" viewBox="0 0 9 9">
                        <g id="q_mark" transform="translate(-424 -33.5)">
                            <g id="長方形_57665" data-name="長方形 57665" transform="translate(424 33.5)" stroke="#000" stroke-width="1">
                            <rect width="9" height="9" rx="4.5" stroke="none"/>
                            <rect x="0.5" y="0.5" width="8" height="8" rx="4" fill="none"/>
                            </g>
                            <path id="パス_91958" data-name="パス 91958" d="M2.968-1.8h.9C3.766-2.772,5.292-2.891,5.292-3.92c0-.931-.742-1.4-1.757-1.4a2.329,2.329,0,0,0-1.806.854l.574.532a1.484,1.484,0,0,1,1.12-.553c.546,0,.882.238.882.658C4.305-3.15,2.821-2.9,2.968-1.8ZM3.423.063a.592.592,0,0,0,.616-.616.594.594,0,0,0-.616-.623.6.6,0,0,0-.616.623A.592.592,0,0,0,3.423.063Z" transform="translate(425 41)" fill="#fff"/>
                        </g>
                    </svg>
                    ヘルプ
                </button>
                <h1 class="logo" @click="reload"><img src="../../assets/img/myroomsimulation.svg" alt="マイルームシミュレーション" width="231" height="30"></h1>
            </div>
        </div>
    </header>
</template>

<script>
    import { mapActions, mapState, mapMutations } from "vuex";
    import CONST from '../../assets/js/const'
    import Util from '../../assets/js/util'
    const {EDIT_CIRCLE_RADIUS, EDIT_RECT_SIZE} = CONST

    export default {
        name: "TempHeader",
        props: {
            bootup: {
                type: Boolean,
                default: false
            }
        },
        // components: {},
        data () {
            return {
                curtain2: [[32,22], [64,22], [32,47], [64,47]] //「製品を追加」時の座標/10
            }
        },
        computed: {
        //   ...mapState('item_data', ["curtain_data"]),
          ...mapState('simulator', ["editing_id"])
        },
        methods:{
            ...mapMutations('simulator', ["createTempItem", "deleteTempItem", "updateTempItem", "setIsContinuingLoading"]),
            ...mapActions('simulator', ["updateItemInfo", "commitTempItem", "resetItemList"]),
            ...mapActions(["resetTimer"]),
            ...mapMutations(['setModal']),
            reload () {
                window.location.reload()
            },
            async setupTempItem () {
                // await this.updateItemInfo({id: this.editing_id, curtain_type: null});
                const item_type = CONST.ITEM_TYPE_CURTAIN;
                const curtain_type = 'LD-WD-89'; //とりあえず軽いモデルを適用

                this.createTempItem();
                this.updateTempItem({
                    points: {
                        top_left:     {x: EDIT_CIRCLE_RADIUS, y: EDIT_CIRCLE_RADIUS},
                        top_right:    {x: EDIT_RECT_SIZE,     y: EDIT_CIRCLE_RADIUS},
                        bottom_left:  {x: EDIT_CIRCLE_RADIUS, y: EDIT_RECT_SIZE},
                        bottom_right: {x: EDIT_RECT_SIZE,     y: EDIT_RECT_SIZE},
                    },
                    rect_width: 1810,
                    rect_height: 1350,
                    item_type,
                    curtain_type,
                });
                this.setPosition(this.curtain2);
                await this.commitTempItem();
                this.deleteTempItem();

                this.setModal('SelectProducts');
                this.resetTimer();
            },
            getRectWidthFromItemType(item_type) {
                switch (item_type) {
                    case CONST.ITEM_TYPE_CURTAIN: { return 200; }
                    case CONST.ITEM_TYPE_WALL: { return 300; }
                    case CONST.ITEM_TYPE_FLOOR: { return 400; }
                }
            },
            async setPosition(points) {
                const calculated_points = Util.calculatePoint(points);
                this.updateTempItem({points: calculated_points});
            }
        }
    }
</script>

<style scoped lang="scss">
  .header_container {
    box-sizing: border-box;
    margin: 0 calc(22 / 667 * 100%);
    display: grid;
    grid-template-columns: calc(388 / 623 * 100%) 1fr;
    height: 100%;
    .header_control {
      display: flex;
      align-items: center;
      .company_logo {
        margin-right: calc(20 / 388 * 100%);
        width: calc(118 / 388 * 100%);
        height: auto;
        > img {
          max-width: 100%;
          height: auto;
        }
      }
      .header_nav {
        flex: 1 0 auto;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        gap: 0 10px;
      }
    }
    .logo_container {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      gap: 0 calc(10 / 255 * 100%);
      .logo {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        margin: 0;
        width: calc(154 / 255 * 100%);
        > img {
          width: 100%;
          height: auto;
          max-height: 30px;
        }
      }
    }
    [class^=btn_] {
      white-space: pre;
      display: flex;
      place-items: center;
      appearance: none;
      padding: 0;
      padding-inline: calc(10 / 388 * 100%);
      font-size: clamp(10px, 1vw, 18px);
      border: 1px solid #040404;
      border-radius: 3px;
      background-color: #fff;
      svg {
        margin-right: 2px;
        width: 1em;
        height: auto;
      }
      &:hover, &:active {
        color: #fff;
        background-color: #000;
        svg {
          fill: #fff;
        }
      }
    }
    .btn_help {
      flex: 0 1 auto;
      &:hover svg path {
        fill: #000;
      }
    }
  }
</style>
